  <mat-card appearance="outlined" class="mt-2">
  <form>
  <mat-form-field class="fullwidth" appearance="fill">
    <mat-label>Korisnik</mat-label>
    <input matInput (ngModelChange)="onchangeKorisnik($event)"
           aria-label="Korisnik"
           [matAutocomplete]="auto"
           [(ngModel)]="korisnikCtrl">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let korisnik of listakorisnika" [(value)]="korisnik.sifra">
        <span>{{korisnik.sifra}}</span>&nbsp;
        <span>{{korisnik.ime}}</span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  </form>
</mat-card>
